export enum ProjectKeyScopes {
    ProjectRead = 'project.read',
    ProjectWrite = 'project.write',
    UsageRead = 'usage.read',
    KeysRead = 'keys.read',
    KeysWrite = 'keys.write',
    PlatformsRead = 'platforms.read',
    PlatformsWrite = 'platforms.write',
    MocksRead = 'mocks.read',
    MocksWrite = 'mocks.write',
    PoliciesRead = 'policies.read',
    PoliciesWrite = 'policies.write',
    ProjectPoliciesRead = 'project.policies.read',
    ProjectPoliciesWrite = 'project.policies.write',
    ProjectOauth2Read = 'project.oauth2.read',
    ProjectOauth2Write = 'project.oauth2.write',
    TemplatesRead = 'templates.read',
    TemplatesWrite = 'templates.write',
    StagesRead = 'stages.read',
    StagesWrite = 'stages.write',
    UsersRead = 'users.read',
    UsersWrite = 'users.write',
    SessionsRead = 'sessions.read',
    SessionsWrite = 'sessions.write',
    TeamsRead = 'teams.read',
    TeamsWrite = 'teams.write',
    DatabasesRead = 'databases.read',
    DatabasesWrite = 'databases.write',
    TablesRead = 'tables.read',
    TablesWrite = 'tables.write',
    ColumnsRead = 'columns.read',
    ColumnsWrite = 'columns.write',
    IndexesRead = 'indexes.read',
    IndexesWrite = 'indexes.write',
    RowsRead = 'rows.read',
    RowsWrite = 'rows.write',
    EmbeddingsWrite = 'embeddings.write',
    CollectionsRead = 'collections.read',
    CollectionsWrite = 'collections.write',
    AttributesRead = 'attributes.read',
    AttributesWrite = 'attributes.write',
    DocumentsRead = 'documents.read',
    DocumentsWrite = 'documents.write',
    DocumentsdbRead = 'documentsdb.read',
    DocumentsdbWrite = 'documentsdb.write',
    DocumentsdbCollectionsRead = 'documentsdb.collections.read',
    DocumentsdbCollectionsWrite = 'documentsdb.collections.write',
    DocumentsdbDocumentsRead = 'documentsdb.documents.read',
    DocumentsdbDocumentsWrite = 'documentsdb.documents.write',
    DocumentsdbIndexesRead = 'documentsdb.indexes.read',
    DocumentsdbIndexesWrite = 'documentsdb.indexes.write',
    VectorsdbRead = 'vectorsdb.read',
    VectorsdbWrite = 'vectorsdb.write',
    VectorsdbCollectionsRead = 'vectorsdb.collections.read',
    VectorsdbCollectionsWrite = 'vectorsdb.collections.write',
    VectorsdbDocumentsRead = 'vectorsdb.documents.read',
    VectorsdbDocumentsWrite = 'vectorsdb.documents.write',
    VectorsdbIndexesRead = 'vectorsdb.indexes.read',
    VectorsdbIndexesWrite = 'vectorsdb.indexes.write',
    BucketsRead = 'buckets.read',
    BucketsWrite = 'buckets.write',
    FilesRead = 'files.read',
    FilesWrite = 'files.write',
    TokensRead = 'tokens.read',
    TokensWrite = 'tokens.write',
    FunctionsRead = 'functions.read',
    FunctionsWrite = 'functions.write',
    ExecutionsRead = 'executions.read',
    ExecutionsWrite = 'executions.write',
    ExecutionRead = 'execution.read',
    ExecutionWrite = 'execution.write',
    SitesRead = 'sites.read',
    SitesWrite = 'sites.write',
    LogRead = 'log.read',
    LogWrite = 'log.write',
    ProvidersRead = 'providers.read',
    ProvidersWrite = 'providers.write',
    TopicsRead = 'topics.read',
    TopicsWrite = 'topics.write',
    SubscribersRead = 'subscribers.read',
    SubscribersWrite = 'subscribers.write',
    TargetsRead = 'targets.read',
    TargetsWrite = 'targets.write',
    MessagesRead = 'messages.read',
    MessagesWrite = 'messages.write',
    RulesRead = 'rules.read',
    RulesWrite = 'rules.write',
    WebhooksRead = 'webhooks.read',
    WebhooksWrite = 'webhooks.write',
    LocaleRead = 'locale.read',
    AvatarsRead = 'avatars.read',
    AvatarsWrite = 'avatars.write',
    HealthRead = 'health.read',
    AssistantRead = 'assistant.read',
    MigrationsRead = 'migrations.read',
    MigrationsWrite = 'migrations.write',
    SchedulesRead = 'schedules.read',
    SchedulesWrite = 'schedules.write',
    VcsRead = 'vcs.read',
    VcsWrite = 'vcs.write',
    InsightsRead = 'insights.read',
    InsightsWrite = 'insights.write',
    ReportsRead = 'reports.read',
    ReportsWrite = 'reports.write',
    PresencesRead = 'presences.read',
    PresencesWrite = 'presences.write',
    DedicatedDatabasesExecute = 'dedicatedDatabases.execute',
    BackupsPoliciesRead = 'backups.policies.read',
    BackupsPoliciesWrite = 'backups.policies.write',
    ArchivesRead = 'archives.read',
    ArchivesWrite = 'archives.write',
    RestorationsRead = 'restorations.read',
    RestorationsWrite = 'restorations.write',
    DomainsRead = 'domains.read',
    DomainsWrite = 'domains.write',
    WafRulesRead = 'wafRules.read',
    WafRulesWrite = 'wafRules.write',
    EventsRead = 'events.read',
    ProxyInvalidationsWrite = 'proxy.invalidations.write',
    AppsRead = 'apps.read',
    AppsWrite = 'apps.write',
    Oauth2Read = 'oauth2.read',
    Oauth2Write = 'oauth2.write',
    Oauth2Introspect = 'oauth2.introspect',
    AnalyticsRead = 'analytics.read',
    AnalyticsWrite = 'analytics.write',
}
